import { InjectionToken } from "@angular/core";

// export class Appconstants {
export const API_ROOT = new InjectionToken<string>("API_ROOT");
export const PCP_URL = new InjectionToken<string>("PCP_URL");
export const APPINSIGHTS_KEY = new InjectionToken<string>("APPINSIGHTS_KEY");
export const TARGET = new InjectionToken<string>("TARGET");
export const STORAGE = new InjectionToken<string>("STORAGE");
export const SECURE_LOCAL_STORAGE = new InjectionToken<string>("SECURE_LOCAL_STORAGE");
export const SECURE_SESSION_STORAGE = new InjectionToken<string>("SECURE_SESSION_STORAGE");

// }
